import React from 'react';
import cn from 'classnames';
import { ChevronDown, ChevronUp } from 'lucide-react';

export interface CollapseExpandProps {
  className?: string;
  isCollapse?: boolean;
  onClick: () => void;
}

function CollapseExpand(props: CollapseExpandProps) {
  return (
    <div
      className={cn(props.className)}
      onClick={() => {
        props.onClick();
      }}
    >
      {props.isCollapse ? (
        <ChevronDown size={20} color="#374151" strokeWidth={2} />
      ) : (
        <ChevronUp size={20} color="#374151" strokeWidth={2} />
      )}
    </div>
  );
}

export default CollapseExpand;
